<div class="camera-wrapper">
    <!-- Camera -->
    <div class="camera-container">
        <video #video autoplay playsinline></video>

        <canvas #canvas hidden></canvas>
    </div>
    <!-- Action Bar -->
    <div class="camera-actions" *ngIf="cameraItems.length > 0">
        <div class="row">
            <div class="col-1">
                <button class="button_icon button_icon_color" (click)="stopCamera()">
                    cancel
                </button>
            </div>
            <div class="col-10">
                <div style="text-align: center;">
                    &nbsp;
                    <ngx-select *ngIf="cameraItems.length > 2" [(ngModel)]="currentDeviceId" [noAutoComplete]="true"
                        [items]="cameraItems" [optionValueField]="'key'" [optionTextField]="'value'"
                        (select)="onCameraChange()" appendTo="body">
                    </ngx-select>
                    <button *ngIf="cameraItems.length == 2" class="button_icon button_icon_color"
                        (click)="switchCamera()">
                        cameraswitch
                    </button>
                </div>
            </div>
            <div class="col-1">
                <button class="button_icon button_icon_color" (click)="capture()">
                    photo_camera
                </button>
            </div>
        </div>
    </div>
</div>